import { render, staticRenderFns } from "./SettingsPostReports.vue?vue&type=template&id=0bff4308"
import script from "./SettingsPostReports.vue?vue&type=script&lang=js"
export * from "./SettingsPostReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports